const RICOS_VERSION = "10.143.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
